import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import NewsList from "@/pages/NewsList";
import ArticleDetail from "@/pages/ArticleDetail";
import Legislation from "@/pages/Legislation";
import StatePage from "@/pages/StatePage";
import GuestArticles from "@/pages/GuestArticles";
import Information from "@/pages/Information";
import Events from "@/pages/Events";
import Resources from "@/pages/Resources";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import SearchPage from "@/pages/SearchPage";
import NewsletterArchive from "@/pages/NewsletterArchive";
import NewsletterDetail from "@/pages/NewsletterDetail";
import Admin from "@/pages/Admin";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/news" element={<NewsList />} />
          <Route path="/news/:slug" element={<ArticleDetail />} />
          <Route path="/legislation" element={<Legislation />} />
          <Route path="/legislation/:code" element={<StatePage />} />
          <Route path="/articles" element={<GuestArticles />} />
          <Route path="/articles/:id" element={<ArticleDetail guest />} />
          <Route path="/information" element={<Information />} />
          <Route path="/events" element={<Events />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/newsletter" element={<NewsletterArchive />} />
          <Route path="/newsletter/:slug" element={<NewsletterDetail />} />
          <Route path="/search" element={<SearchPage />} />
        </Route>
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
